import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card', 'detail'];

  toggle(event) {
    const card = event.currentTarget;
    const detail = card.querySelector('[data-tax-center--deadline-sidebar-target="detail"]');
    if (!detail) return;

    const isOpen = !detail.classList.contains('d-none');

    // Close all
    this.detailTargets.forEach((d) => d.classList.add('d-none'));
    this.cardTargets.forEach((c) => c.classList.remove('tc-deadline-card--open'));

    // Toggle clicked
    if (!isOpen) {
      detail.classList.remove('d-none');
      card.classList.add('tc-deadline-card--open');
    }
  }

  connect() {
    // Start with all details collapsed
    this.detailTargets.forEach((d) => d.classList.add('d-none'));
  }
}
